import { call, put } from 'redux-saga/effects';
import { normalizeDeviations } from '../../redux/normalizr/helpers';
import { withOffset } from '../../Stream';
import { request } from '../../xhr';
export function fakeResponse({ params  }) {
    if (process.env.NODE_ENV !== 'production') {
        const { deviationsByType  } = require('@wix/da-sample-data'); // eslint-disable-line global-require
        const { Chance  } = require('chance'); // eslint-disable-line global-require
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        const randomDeviations = new Chance().pickset(deviationsByType.tiers, 10);
        return {
            hasMore: false,
            results: randomDeviations
        };
    }
}
function* fetch(url, params) {
    const response = yield call(request, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function* handleTierStreamFetch(action) {
    const { streamId  } = action;
    const response = yield call(fetch, 'tier/user/list', {});
    if (!response) {
        yield put(withOffset.actions.fetchFailure({
            streamId,
            errorMsg: 'Failed to fetch'
        }));
        return;
    }
    const { results  } = response;
    const normalized = results && normalizeDeviations(results);
    var _normalized_result, _normalized_entities;
    yield put(withOffset.actions.fetchSuccess({
        streamId,
        hasMore: false,
        items: (_normalized_result = normalized === null || normalized === void 0 ? void 0 : normalized.result) !== null && _normalized_result !== void 0 ? _normalized_result : [],
        entities: (_normalized_entities = normalized === null || normalized === void 0 ? void 0 : normalized.entities) !== null && _normalized_entities !== void 0 ? _normalized_entities : {}
    }));
}
export default handleTierStreamFetch;
